
export default {
    emptyCategory: {
        title: 'Δεν υπάρχουν μετρήσεις σε αυτή την κατηγορία',
        subtitle: 'Μπορείς να ενεργοποιήσεις μετρήσεις από τις «{settings}».'
    },
    tabs: {
        general: 'Γενικές σημειώσεις',
        progress: 'Προβολή προόδου μετρήσεων',
        body: 'Σωματομετρικές',
        dermatoptixes: 'Δερματοπτυχές',
        mezoures: 'Μεζούρες',
        vitamins: 'Βιταμίνες',
        bloodGeneral: 'Γενικές Αιματολογικές',
        biochemicals: 'Βιοχημικές',
        hormonological: 'Ορμονολογικές',
        bloodWork: 'Αιματολογικές',
        extra: 'Extra (λιπομετρητές)'
    },
    settings: 'Ρυθμίσεις μετρήσεων',
    printFatMeter: 'Εκτύπωση Λιπομετρητή',
    print: 'Εκτύπωση',
    printMeasurements: 'Εκτύπωση Μετρήσεων',
    progress: 'Προβολή προόδου',
    massImport: 'Μαζική εισαγωγή μετρήσεων',
    add: 'Προσθήκη μετρήσεων',
    date: 'Ημερομηνία μέτρησης',
    value: 'Τιμή μέτρησης',
    general: {
        title: 'Γενικές σημειώσεις',
        subtitle: 'Πληκτρολογήστε σημειώσεις για τις μετρήσεις του πελάτη σας ώστε να μην τις ξεχάσετε!'
    },
    fatMeter: {
        intro: 'Με αυτή τη λειτουργία μπορείτε να εισάγετε λιπομέτρηση από τον λιπομετρητή σας (CSV αρχείο).',
        insert: 'Εισαγωγή μετρήσεων',
        closeWithoutSave: 'Κλείσιμο χωρίς αποθήκευση',
        invalidCsv: 'Το CSV που έχετε εισάγει είναι εσφαλμένο. Επιλέξατε τον σωστό λιπομετρητή;',
        noMeasurement: 'Δεν βρέθηκε καμία μέτρηση στο αρχείο. Έλεγξε ότι είναι το CSV που εξήγαγες από τον λιπομετρητή σου.',
        sections: {
            general: 'Γενικά',
            waterProtein: 'Νερό & Πρωτεΐνες',
            muscleSegments: 'Μυϊκή μάζα ανά τμήμα',
            fatKgSegments: 'Λίπος ανά τμήμα (kg)',
            fatPerSegments: 'Λίπος ανά τμήμα (%)',
            phaseAngle: 'Γωνία φάσης (50kHz)',
            mezoures: 'Μεζούρες',
        }
    },
    printModal: {
        tabs: {
            base: 'Βασικά στοιχεία',
            options: 'Επιλογές Εκτύπωσης',
        },
        showDiagrams: 'Προβολή διαγραμμάτων',
        showText: 'Προβολή κειμένου',
        progress: 'Πρόοδος πελάτη',
        filterByNumber: 'Αριθμός μετρήσεων',
        filterByDateRange: 'Εύρος ημερομηνιών',
        limitAll: 'Όλες',
        limitCustom: 'Προσαρμοσμένο',
        numberOfMeasurements: 'Αριθμός (τελευταίες N)',
        lastMeasurements: 'Τελευταία {count}|Τελευταίες {count}',
        newestMeasurementsNotice: 'Χρησιμοποιούνται οι πιο πρόσφατες (νεότερες) μετρήσεις.',
        dateFrom: 'Από',
        dateTo: 'Έως'
    },
    printFatMeterModal: {
        missingHeight: 'Προσοχή! Δεν έχετε εισάγει το\n' +
            '            <strong>ύψος</strong> του πελάτη σας.',
        missingWeight: '  Προσοχή! Δεν έχετε εισάγει <strong>βάρος</strong> για τον πελάτη σας και η εκτύπωση δεν μπορεί να\n' +
            '            λειτουργήσει σωστά.',
        measurementDate: 'Ημερομηνία μέτρησης',
        dateLatest: 'Τελευταία (πιο πρόσφατη)',
        dateLatestWithDate: 'Τελευταία ({date})',
        earlierMeasurementsWarningBefore: 'Οι μετρήσεις ',
        earlierMeasurementsWarningAfter: ' προέρχονται από παλαιότερες λιπομετρήσεις!',
        earlierMeasurementsWarningBeforeSingular: 'Η μέτρηση ',
        earlierMeasurementsWarningAfterSingular: ' προέρχεται από παλαιότερη λιπομέτρηση.',
        hideEarlierMeasurements: 'Απόκρυψη από την εκτύπωση',
        information: 'ΠΛΗΡΟΦΟΡΙΕΣ',
        results: 'ΑΠΟΤΕΛΕΣΜΑΤΑ ΜΕΤΡΗΣΗΣ',
        partialAnalysis: 'ΤΜΗΜΑΤΙΚΗ ΑΝΑΛΥΣΗ',
        phaseAngleAnalysis: 'ΓΩΝΙΑ ΦΑΣΗΣ (50kHz)',
        phaseAngleWholeBody: 'ΟΛΙΚΟ ΣΩΜΑ',
        phaseAngleSegments: 'ΤΜΗΜΑΤΙΚΑ',
        composition: 'ΣΥΣΤΑΣΗ ΣΩΜΑΤΟΣ',
        clothes: 'Ρούχα',
        result: 'Αποτελέσματα',
        recommended: 'Επιθυμητά',
        normalRange: 'Φυσιολογικά όρια',
        muscles: 'Μύες',
        torso: 'ΚΟΡΜΟΣ',
        ecwRatio: 'ECW Ratio',
        phaseAngle: 'Γωνία φάσης',
        proteins: 'Πρωτεΐνες',
        printLanguage: 'Γλώσσα εκτύπωσης',
        emailSubject: 'Λιπομέτρηση - {date}',
        emailContent: 'Έχουν επισυναφθεί τα αποτελέσματά σας!'
    },
    progressCard:{
        title: 'Πρόοδος μετρήσεων',
        subtitle: 'Δείτε συγκεντρωτικά την πρόοδο των μετρήσεων του πελάτη σας',
        info: 'Επιλέξτε μετρήσεις (ενεργές εμφανίζονται όσες έχετε περασμένες μετρήσεις)'
    },
    settingsIntro: ' <p>\n' +
        '            Αλλάζοντας τις ρυθμίσες αυτές, θα σταματήσουν να εμφανίζονται οι μετρήσεις που έχετε από-επιλέξει.<br> Δεν\n' +
        '            θα εμφανίζονται ούτε στην μαζική πρόοδο των μετρήσεων,\n' +
        '            ούτε στη μαζική εισαγωγή.<br>\n' +
        '            <i>Σημείωση: Δεν θα χαθούν μετρήσεις που έχετε ήδη εισάγει!</i>\n' +
        '          </p>',
    single: {
        edit: 'Επεξεργασία μέτρησης',
        progressNoEditable: 'Αυτή η μέτρηση έχει περαστεί από το φύλλο παρακολούθησης και δεν μπορεί να επεξεργαστεί εδώ',
        choose: 'ΕΠΙΛΟΓΗ ΜΕΤΡΗΣΗΣ',
        history: 'Ιστορικό Μετρήσεων',
        diagram: 'Διάγραμμα μεταβολής',
        add: 'Προσθήκη μέτρησης',
        empty: 'Δεν υπάρχουν μετρήσεις για «{name}»',
        emptySubtitle: 'Καταχώρησε την πρώτη μέτρηση από την παρακάτω φόρμα.',
        normalRange: 'Φυσιολογικό εύρος τιμών',
        notePlaceholder: 'Σημειώσεις σχετικά με τη μέτρηση',
        missingMeasurementLink: 'Λείπει κάποιο είδος εξέτασης / μέτρησης;',
        record: 'εγγραφή | εγγραφές'
    },
    skinfold: {
        title: 'Αναλυση Δερματοπτυχων',
        button: 'Δερματοπτυχές',
        tabEntry: 'Μέτρηση & Αποτελέσματα',
        protocol: 'Πρωτόκολλο',
        protocolJP3: 'Jackson-Pollock 3 σημείων',
        protocolJP7: 'Jackson-Pollock 7 σημείων',
        protocolDW4: 'Durnin-Womersley 4 σημείων',
        protocolFAULKNER: 'Faulkner (1968)',
        protocolCARTER: 'Carter / Yuhasz',
        protocolISAK: 'ISAK (8 σημείων)',
        measurementDate: 'Ημερομηνία μέτρησης',
        dateLatest: 'Τελευταία',
        dateLatestWithDate: 'Τελευταία ({date})',
        weight: 'Βάρος (kg)',
        weightPlaceholder: 'Βάρος σε kg',
        weightAutoFilled: 'Αυτόματη συμπλήρωση από τις μετρήσεις',


        results: 'Αποτελέσματα',
        bodyDensity: 'Πυκνότητα Σώματος',
        fatPercent: 'Ποσοστό Λίπους %',
        fatPercentSiri: 'Λίπος % (Siri)',
        fatPercentBrozek: 'Λίπος % (Brozek)',
        fatMass: 'Λιπώδης Μάζα',
        fatFreeMass: 'Άλιπη Μάζα',
        sumOfFolds: 'Άθροισμα Δερματοπτυχών',
        category: 'Κατηγοριοποίηση',
        allSites: 'Όλα τα σημεία',
        newMeasurement: 'Νέα μέτρηση',
        save: 'Αποθήκευση μετρήσεων',
        selectProtocolForResults: 'Επιλέξτε πρωτόκολλο για να δείτε αποτελέσματα',
        duplicateDate: 'Κάποιες μετρήσεις υπάρχουν ήδη για αυτή την ημερομηνία και είναι προσυμπληρωμένες. Μπορείτε να προσθέσετε τις υπόλοιπες.',
        duplicateDateLink: 'Προβολή όλων των μετρήσεων για αυτή την ημερομηνία',
        missingSites: 'Συμπληρώστε τα απαιτούμενα σημεία για τον υπολογισμό',
        missingWeight: 'Εισάγετε βάρος για τον υπολογισμό λιπώδους/άλιπης μάζας',
        noData: 'Δεν βρέθηκαν δεδομένα δερματοπτυχών για αυτή την ημερομηνία',
        diagramFront: 'Μπροστά',
        diagramBack: 'Πίσω',
        viewAnalysis: 'Ανάλυση',
        viewIndividual: 'Μεμονωμένες',
    }

}
